import React, { useState, createContext, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { userSelector } from 'Redux/LoggedUserSlice';
import {
  Apps,
  WorkOutline,
  DeviceHub,
  Business,
  AccountTree,
  Extension,
  PeopleAlt,
  Computer,
  School,
  WorkspacePremium,
  SettingsSuggest,
} from '@mui/icons-material/';
import useTranslation from 'Hooks/useTranslation';
import fetchRolePermissions from 'Api/rolePermissions';

export const GeneralContext = createContext();

export function ContextProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState('/dashboard');
  const [rolePermissions, setRolePermissions] = useState([]);
  const { roleId } = useSelector(userSelector);
  const { t2 } = useTranslation('SideBar');

  const PermissionJobTitle = {
    icon: <WorkOutline />,
    route: '/puestos',
    text: t2('JobTitle'),
  };
  const PermissionDepartments = {
    icon: <DeviceHub />,
    route: '/departamentos',
    text: t2('Departments'),
  };
  const PermissionEnterprise = {
    icon: <Business />,
    route: '/empresa',
    text: t2('Company'),
  };
  const PermissionCoursesDefinition = {
    icon: <AccountTree />,
    route: '/definicion',
    text: t2('DefinitionCourses'),
  };
  const PermissionDevelopmentPlan = {
    icon: <Extension />,
    route: '/reporte/empleados',
    text: t2('reports'),
  };
  const PermissionEmployees = {
    icon: <PeopleAlt />,
    route: '/empleados',
    text: t2('Employees'),
  };
  const PermissionProfile = {
    icon: <School />,
    route: '/cursos/',
    text: t2('Courses'),
  };
  const PermissionAchievements = {
    icon: <WorkspacePremium />,
    route: '/insignias',
    text: t2('Achievements'),
  };
  const PermissionRoles = {
    icon: <SettingsSuggest />,
    route: '/roles',
    text: t2('Management'),
  };

  const permissionItems = {
    JobTitles: PermissionJobTitle,
    Departments: PermissionDepartments,
    Enterprise: PermissionEnterprise,
    CoursesDefinition: PermissionCoursesDefinition,
    DevelopmentPlan: PermissionDevelopmentPlan,
    Employees: PermissionEmployees,
    Profile: PermissionProfile,
    Achievements: PermissionAchievements,
    Management: PermissionRoles,
  };

  const baseItems = [
    { icon: <Apps />, route: '/dashboard', text: t2('Dashboard') },
    {
      icon: <PeopleAlt />,
      route: '/empleado/me',
      text: t2('Profile'),
    },
    { icon: <Computer />, route: '/mis-cursos', text: t2('MyCourses') },
  ];

  useEffect(() => {
    // if (roleId) {
    //   fetchRolePermissions(roleId, true).then(data => {
    //     const mappedPermissions = data.map(permission => permissionItems[permission.name.split(' ')[1]]);
    //     if (mappedPermissions.length > 0) {
    //       const course = mappedPermissions.pop();
    //       const finalArray = [baseItems[0], ...mappedPermissions, baseItems[2], course];
    //       setRolePermissions(finalArray);
    //     }
    //     if (mappedPermissions.length === 0) {
    //       setRolePermissions(baseItems);
    //     }
    //   });
    // }
  }, [roleId]);

  const contextValue = useMemo(
    () => ({
      open,
      setOpen,
      selectedOption,
      setSelectedOption,
      rolePermissions,
    }),
    [open, selectedOption, rolePermissions]
  );

  return <GeneralContext.Provider value={contextValue}>{children}</GeneralContext.Provider>;
}
